const userAgent = navigator.userAgent;
export const isCrawler = /baidu|(?:google|bing|yandex|duckduck)bot/i.test(
  userAgent
);
export const isIE = /Trident/.test(userAgent);

const win = window;
export const supportsIntersectionObserver =
  'IntersectionObserver' in win && 'IntersectionObserverEntry' in win;
export const supportsRequestIdleCallback = 'requestIdleCallback' in win;

/**
 * A helper for repeating the query in search of valid lazyloading elements.
 *
 * @param {string} query
 * @returns {HTMLElement[]}
 */
export function findElements(query) {
  return /** @type {HTMLElement[]} */ (
    Array.from(document.querySelectorAll(query))
  );
}

/**
 * A wrapper for the common use-case of looping through a list and applying
 * a function.
 *
 * @template T
 * @param {T[]} items
 * @param {(param: T) => void} fn
 * @return {void}
 */
export function applyEach(items, fn) {
  items.forEach((item) => fn(item));
}
